import React, {useState} from "react";

const Accordion = ({children, defaultOpen = false, buttonClasses = ""}) => {
    const [isOpen, setIsOpen] = useState(defaultOpen);
    const btnClass = `${buttonClasses} accordion-button`;

    return (
        <div className="accordion flex-fill">
            <div className="accordion-item h-100">
                {React.Children.map(children, (child) =>
                    React.cloneElement(child, {isOpen, setIsOpen, btnClass})
                )}
            </div>
        </div>
    );
};

const Header = ({children, setIsOpen, isOpen, btnClass}) => {
    return (
        <h2 className="accordion-header">
            <button
                className={`${btnClass} ${!isOpen ? "collapsed" : ""}`.trim()}
                type="button"
                onClick={() => setIsOpen(!isOpen)}
            >
                {children}
            </button>
        </h2>
    );
};

const Body = ({children, isOpen}) => {
    return (
        <div
            className={`accordion-collapse collapse ${isOpen ? "show" : ""}`}
        >
            <div className="accordion-body">{children}</div>
        </div>
    );
};

Accordion.Header = Header;
Accordion.Body = Body;

export default Accordion;
